/**
 * @generated SignedSource<<5be034959c3abba7fadddc06ee19c0e8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MeetingBriefs_useShowMeetingBriefSuggestedAction$data = {
  readonly event: {
    readonly attendeePersonCount: number;
    readonly externalAttendeePersonCount: number;
    readonly timeBlockType: string | null;
  } | null;
  readonly eventEnd: string | null;
  readonly eventStart: string | null;
  readonly groupName: string;
  readonly id: string;
  readonly meetingBrief: {
    readonly id: string;
  } | null;
  readonly previousNoteWithEvent: {
    readonly meetingRecordings: ReadonlyArray<{
      readonly id: string;
    }> | null;
  } | null;
  readonly " $fragmentType": "MeetingBriefs_useShowMeetingBriefSuggestedAction";
};
export type MeetingBriefs_useShowMeetingBriefSuggestedAction$key = {
  readonly " $data"?: MeetingBriefs_useShowMeetingBriefSuggestedAction$data;
  readonly " $fragmentSpreads": FragmentRefs<"MeetingBriefs_useShowMeetingBriefSuggestedAction">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./MeetingBriefsShowMeetingBriefSuggestedActionQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "MeetingBriefs_useShowMeetingBriefSuggestedAction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Event",
      "kind": "LinkedField",
      "name": "event",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timeBlockType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "attendeePersonCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "externalAttendeePersonCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventEnd",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "groupName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Note",
      "kind": "LinkedField",
      "name": "previousNoteWithEvent",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MeetingRecording",
          "kind": "LinkedField",
          "name": "meetingRecordings",
          "plural": true,
          "selections": (v1/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingBrief",
      "kind": "LinkedField",
      "name": "meetingBrief",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    (v0/*: any*/)
  ],
  "type": "Note",
  "abstractKey": null
};
})();

(node as any).hash = "576d724fe8adb696e0f0e6f626660bf0";

export default node;
